<template>
	<main class="vx-row">
		<div class="vx-col w-full">
			<vx-card>
				<h5 class="mb-4">Form Zakat Maal</h5>
				<vs-alert :color="color" v-if="zakatCaption !== null" class="mt-4 mb-6">
				<strong>{{ zakatCaption }}</strong>
				</vs-alert>

				<form>
					<span class="text-danger text-sm my-6" v-show="errors.has('gold')">{{ errors.first('gold') }}</span>
					<p class="mb-2"><strong>Nilai emas, perak, dan/atau permata</strong></p>
					<vs-input
					    type="number"
					    v-model="gold"
					    class="w-full mb-6"
					    size="large"
					    v-validate="'required'"
					    dir="rtl"
					    name="gold"
					/>

					<span class="text-danger text-sm my-6" v-show="errors.has('cash')">{{ errors.first('cash') }}</span>
					<p class="mb-2"><strong>Uang tunai, tabungan, deposito</strong></p>
					<vs-input
					    type="number"
					    v-model="cash"
					    class="w-full mb-6"
					    size="large"
					    v-validate="'required'"
					    dir="rtl"
					    name="cash"
					/>

					<span class="text-danger text-sm my-6" v-show="errors.has('asset_invest')">{{ errors.first('asset_invest') }}</span>
					<p class="mb-2"><strong>Kendaraan, rumah, aset lain</strong></p>
					<vs-input
					    type="number"
					    v-model="asset_invest"
					    class="w-full mb-6"
					    size="large"
					    v-validate="'required'"
					    dir="rtl"
					    name="asset_invest"
					/>

					<span class="text-danger text-sm my-6" v-show="errors.has('debt')">{{ errors.first('debt') }}</span>
					<p class="mb-2"><strong>Jumlah hutang/cicilan (optional)</strong></p>
					<vs-input
					    type="number"
					    v-model="debt"
					    class="w-full mb-6"
					    size="large"
					    dir="rtl"
					    name="debt"
					/>
					<br>
					<vs-button
					    color="primary"
					    size="large"
					    class="w-full mb-4"
					    @click.prevent="calculateZakat"
					>
					Hitung Zakat
					</vs-button>
					<vs-button
					    color="warning"
					    size="large"
					    type="gradient"
					    class="w-full mb-4"
					    v-if="zakat !== 0"
					    @click.prevent="payZakat"
					>
					<span class="text-dark">Bayar {{ capitalize(type) }}</span>
					</vs-button>
				</form>
			</vx-card>
		</div>
			
	</main>
		
</template>
<script>
// For custom error message
import { Validator } from 'vee-validate'
import { minNishabZakat, minMaal } from '@/assets/utils/zakat'

const dict = {
	  custom: {
	    gol: {
	      required: 'Harap masukan nilai emas, perak, atau permata'
	    },
	    cash:  {
	      required: 'Harap masukan nilai uang tunai, tabungan, deposito'
	    },
	    asset_invest:  {
	      required: 'Harap masukan nilai kendaraan, rumah, aset lain'
	    }
	  }
}

// register custom messages
Validator.localize('en', dict)

export default {
  data: () => ({
    type: 'zakat',
    income: 0.0,
    additional_income: 0.0,
    zakat: 0,
    zakatCaption: null,
    color: 'success',
    gold: 0.0, // emas, perak, permata
    cash: 0.0, // uang tunai, tabunga, deposito
    asset_invest: 0.0, // kendaraan, rumah, aset lain
    debt: 0.0 // jumlah hutamg / cicilan optioanl
  }),
  methods: {
    calculateZakat () {
      this.$validator.validateAll().then(res => {
        if (res) {
          const gold = this.gold !== 0 ? parseFloat(this.gold.replace(/\./g, '')) : 0,
            cash = this.cash !== 0 ? parseFloat(this.cash.replace(/\./g, '')) : 0,
            asset_invest = this.asset_invest !== 0 ? parseFloat(this.asset_invest.replace(/\./g, '')) : 0,
            debt = this.debt !== 0 ? parseFloat(this.debt.replace(/\./g, '')) : 0
          let total = parseFloat(((gold + asset_invest  + cash) - debt) * minNishabZakat)

          if (isNaN(total)) {
            total = 0
          }

          // Check if maal is less than minMaal
          if (total < minMaal) {
            this.zakatCaption = 'Harta Anda belum memenuhi nisab'
            this.color = 'danger'
            this.type = 'infaq'
          } else {
            this.type = 'zakat'
            this.zakat = Math.ceil(total)
            this.color = 'success'
            this.zakatCaption = `Zakat Maal Anda : Rp ${this.formatRupiah(this.zakat.toString())}`	
          }

          window.scrollTo(0, 0)
        }
      })
    },
    payZakat () {
      this.$emit('payZakat', {total: this.zakat, type: this.type})
    }
  }
}
</script>